/**
 * Device Commands Service (Frontend)
 * API calls för tillgängliga kommandon
 */

import api from '../api/client';

export interface DeviceCommand {
  id: number;
  code: string;
  name: string;
  description: string | null;
  codec_version: string;
  command_type: 'GET' | 'SET' | 'ACTION' | 'CONFIG';
  parameters_schema: {
    required?: string[];
    properties?: Record<string, any>;
  };
  example_payload: any;
  supported_devices: string[] | null;
  requires_ack: boolean;
  timeout_seconds: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const deviceCommandsService = {
  /**
   * Hämta alla tillgängliga kommandon
   */
  getAllCommands: async (
    commandType?: 'GET' | 'SET' | 'ACTION' | 'CONFIG',
    deviceModel?: string
  ): Promise<DeviceCommand[]> => {
    const params: any = {};
    if (commandType) params.type = commandType;
    if (deviceModel) params.device_model = deviceModel;

    const response = await api.get('/api/device-commands', { params });
    return response.data.data;
  },

  /**
   * Hämta specifikt kommando efter kod
   */
  getCommandByCode: async (code: string): Promise<DeviceCommand> => {
    const response = await api.get(`/api/device-commands/${code}`);
    return response.data.data;
  },

  /**
   * Hämta specifikt kommando efter ID
   */
  getCommandById: async (id: number): Promise<DeviceCommand> => {
    const response = await api.get(`/api/device-commands/id/${id}`);
    return response.data.data;
  },
};

